import React from 'react';
import Section from '../ui/Section';
import { motion } from 'framer-motion';

const FrameworkPreview = () => {
  const letters = [
    { letter: 'S', title: 'Secure', desc: 'Protect data, people, safeguarding responsibilities, and trust.' },
    { letter: 'A', title: 'Accountable', desc: 'Clear standards, ownership, and review points for leaders.' },
    { letter: 'F', title: 'Future-Ready', desc: 'Adaptable habits that don’t chase every new tool.' },
    { letter: 'E', title: 'Empowered', desc: 'Staff feel confident and capable, not replaced.' },
    { letter: 'A', title: 'Aligned', desc: 'Supports your mission, values, and funder expectations.' },
    { letter: 'I', title: 'Inclusive', desc: 'Considers equity, access, bias, and community impact.' },
  ];

  return (
    <Section bg="navy" className="py-24">
      <div className="text-center mb-20 max-w-3xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">The SAFE AI Framework</h2>
        <p className="text-xl text-gray-300 leading-relaxed">
          The SAFE AI Framework is the leadership methodology behind every piece of work we do. It helps organisations use AI with confidence while protecting the people, values, and trust that define their mission.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {letters.map((item, index) => (
          <motion.div 
            key={index}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1 }}
            viewport={{ once: true }}
            className="bg-white/5 border border-white/10 rounded-3xl p-8 hover:bg-white/10 transition-colors"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-brand-teal text-white rounded-xl flex items-center justify-center text-2xl font-bold">
                {item.letter}
              </div>
              <h3 className="text-xl font-bold text-white">{item.title}</h3>
            </div>
            <p className="text-gray-300 leading-relaxed text-sm">{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
};

export default FrameworkPreview;